import React, { useState } from 'react'
import './GitHubAccountSelectionModal.css'

const GitHubAccountSelectionModal = ({ isOpen, onClose, onContinue }) => {
  const [showSwitchInstructions, setShowSwitchInstructions] = useState(false)
  const [hasOpenedLogout, setHasOpenedLogout] = useState(false)

  if (!isOpen) return null

  const handleContinueWithCurrent = () => {
    onContinue()
    onClose()
  }

  const handleSwitchAccount = () => {
    // Open GitHub logout in a new tab
    window.open('https://github.com/logout', '_blank', 'noopener,noreferrer')
    setHasOpenedLogout(true)
    setShowSwitchInstructions(true)
  }

  const handleProceedAfterLogout = () => {
    onContinue()
    onClose()
    // Reset state for next time
    setShowSwitchInstructions(false)
    setHasOpenedLogout(false)
  }

  const handleCancel = () => {
    onClose()
    // Reset state
    setShowSwitchInstructions(false)
    setHasOpenedLogout(false)
  }

  return (
    <div className="github-modal-overlay" onClick={handleCancel}>
      <div className="github-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="github-modal-close" onClick={handleCancel} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {!showSwitchInstructions ? (
          <>
            <div className="github-modal-icon">
              <svg viewBox="0 0 24 24" width="48" height="48">
                <path fill="currentColor" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </div>

            <h2 className="github-modal-title">Sign in with GitHub</h2>
            <p className="github-modal-description">
              Choose how you want to continue:
            </p>

            <div className="github-modal-options">
              <button
                className="github-modal-button primary"
                onClick={handleContinueWithCurrent}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" className="button-icon">
                  <path fill="currentColor" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                Continue with current GitHub account
              </button>

              <button
                className="github-modal-button secondary"
                onClick={handleSwitchAccount}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" className="button-icon">
                  <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16 17l5-5m0 0l-5-5m5 5H9m0-9H7a2 2 0 00-2 2v11a2 2 0 002 2h2"/>
                </svg>
                Sign in with a different GitHub account
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="github-modal-icon">
              <svg viewBox="0 0 24 24" width="48" height="48">
                <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>

            <h2 className="github-modal-title">Switch GitHub Account</h2>

            <div className="github-modal-instructions">
              <p className="instruction-step">
                <span className="step-number">1</span>
                <span className="step-text">
                  {hasOpenedLogout
                    ? 'A new tab has opened with GitHub logout page'
                    : 'Click the button below to open GitHub logout page'}
                </span>
              </p>

              {!hasOpenedLogout && (
                <button
                  className="github-modal-button secondary small"
                  onClick={handleSwitchAccount}
                >
                  Open GitHub Logout
                </button>
              )}

              <p className="instruction-step">
                <span className="step-number">2</span>
                <span className="step-text">
                  Sign out of GitHub in that tab (if you're already logged in)
                </span>
              </p>

              <p className="instruction-step">
                <span className="step-number">3</span>
                <span className="step-text">
                  Come back here and click the button below to continue
                </span>
              </p>
            </div>

            <div className="github-modal-actions">
              <button
                className="github-modal-button primary"
                onClick={handleProceedAfterLogout}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" className="button-icon">
                  <path fill="currentColor" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                Continue to GitHub Sign In
              </button>
              <button
                className="github-modal-button tertiary small"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default GitHubAccountSelectionModal
